/* BK lazy video: videos marked data-bk-lazy start loading only when they come near the screen.
   data-bk-autoplay videos start playing then, pause when scrolled away, and resume when back
   (unless the shopper paused them). Hidden videos (display:none at this screen size) never load. */
(function () {
  if (window.bkLazyVideo) return;
  window.bkLazyVideo = true;

  function play(v) {
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function start(v) {
    if (v.dataset.bkStarted) return;
    v.dataset.bkStarted = '1';
    v.preload = 'auto';
    if (!v.dataset.bkAutoplay) v.load();
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            start(v);
            if (v.dataset.bkAutoplay && v.paused && (!v.dataset.bkPlayed || v.dataset.bkAutoPaused === '1')) {
              v.dataset.bkAutoPaused = '0';
              v.dataset.bkPlayed = '1';
              play(v);
            }
          } else if (v.dataset.bkAutoplay && !v.paused) {
            v.dataset.bkAutoPaused = '1';
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan(root) {
    (root || document).querySelectorAll('video[data-bk-lazy]:not([data-bk-seen])').forEach(function (v) {
      v.dataset.bkSeen = '1';
      if (io) io.observe(v);
      else { start(v); if (v.dataset.bkAutoplay) play(v); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
